import { useQuery, useQueryClient } from "@tanstack/react-query";

import {
  NOTIFICATIONS_POLL_INTERVAL_MS,
  popupNotificationsQueryKey,
  unreadNotificationsCountQueryKey,
} from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, NotificationResponse } from "@/types";

export function useGetPopupNotifications() {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: popupNotificationsQueryKey,
    refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const path = "notifications/popup";
      const res = await guacHttpClient.get<
        NotificationResponse[],
        HttpResponse<NotificationResponse[]>
      >(path);

      // Popups and the sidebar unread count must stay in sync — every popup
      // poll drives a count refresh too, not just a matching interval.
      void queryClient.invalidateQueries({
        queryKey: unreadNotificationsCountQueryKey,
      });

      return res.data;
    },
  });
}
